/**
 * Event Sources — list + health (read-only, `[PROPOSED]`).
 *
 * `frontend-entity-coverage §2.3`: EventSource is PROPOSED, backed by
 * `/api/event-sources` (`11 §2.1`) with health from `/api/observability/*`
 * (`11 §3.8`); actions enable / disable · trigger sync (`PATCH status` +
 * connector poll). Until that backing ships this is a discoverable, labeled-
 * empty teaser — never a hard error — so the source registry is reachable from
 * nav / ⌘K today and lights up the moment the endpoint lands.
 */
import { Radio } from "@/components/ui/icon";

import { ProposedListPage } from "../_shared/ProposedModule";

export function EventSourceList() {
  return (
    <ProposedListPage
      title="Event Sources"
      description="Connectors that stamp inbound events — with health and last-sync. Enable / disable · trigger sync."
      icon={Radio}
      endpoint="/api/event-sources"
      emptyTitle="No event sources yet"
      testId="event-sources-empty"
    />
  );
}

export default EventSourceList;
